import { IBasePage, Pages } from '../pages.config';

export interface IMenuItem {
    text: string;
    icon?: string;
    router: string;
    onlyShowIfLocationContextIsValid: boolean;
    onlyShowIfLocationContextIsNotValid: boolean;
    restrictionKey: string;
}

function getMenuItemByPage(page: IBasePage): IMenuItem {
    return {
        text: page.name,
        router: page.router,
        icon: page.icon,
        onlyShowIfLocationContextIsValid: page.onlyShowIfLocationContextIsValid,
        onlyShowIfLocationContextIsNotValid: page.onlyShowIfLocationContextIsNotValid,
        restrictionKey: page.restrictionKey
    };
}

export const MainMenuItems: IMenuItem[] = [getMenuItemByPage(Pages.flights), getMenuItemByPage(Pages.docking)];

export const SideMenuItems: IMenuItem[] = [
    getMenuItemByPage(Pages.maintenance),
    getMenuItemByPage(Pages.locationContext)
];
